
















































import Vue from 'vue'
export default Vue.extend({
  props: ['imageGroup', 'barId'],
  watch: {
    imageGroup() {
      this.index = this.imageGroup.length - 1
      this.setItem()
      this._stop()
      // setTimeout(() => {
      //   this.on('play')
      // }, 5000)
    },
  },
  data() {
    return {
      isPlay: true,
      index: 0,
      time: '',
      setInterval: 0,
      timeNum: 0,
      num: 0,
    }
  },
  created() {
    this.index = this.imageGroup.length - 1
    this.setItem()
    // setTimeout(() => {
    //   this.on('play')
    // }, 5000)
    const that = this
    let num = 1
    //@ts-ignore
    this.timeNum = setInterval(() => {
      // console.log(num++)
      num++
      if (num === this.imageGroup.length + 1) {
        // console.log(num)
        that.$emit('getNumShow', that.barId === 'radar' ? 4 : 0)
        clearInterval(that.timeNum);
      }
    }, 2000);
  },
  destroyed() {
    this._stop()
    clearInterval(this.timeNum)
    this.timeNum = 0
  },
  filters: {
    getTime(value: any) {
      //20250620190600
     const Hour = value.substring(8, 10)
      const Minute = value.substring(10, 12)
      return `${Hour}:${Minute}`
    }
  },
  methods: {
    _start() {
      this._next()
      //@ts-ignore
      this.setInterval = setInterval(() => this._next(), 1000)
    },
    _stop() {
      if (!this.setInterval) {
        return
      }
      clearInterval(this.setInterval)
      this.setInterval = 0
    },
    _previous() {
      if (!this.imageGroup || this.imageGroup.length === 0) {
        return
      }
      if (this.index > 0) {
        this.index--
      } else {
        this.index = this.imageGroup.length - 1
      }
      this.setItem()
    },
    _next() {
      if (!this.imageGroup || this.imageGroup.length === 0) {
        return
      }
      if (this.index + 1 < this.imageGroup.length) {
        this.index++
      } else {
        this.index = 0
      }
      this.setItem()
    },
    on(type: string) {
      switch (type) {
        case 'play':
          this.isPlay = !this.isPlay
          if (this.setInterval) {
            this._stop()
          } else {
            this._start()
          }
          break
        case 'previous':
          this.isPlay = false
          this._stop()
          this._previous()
          break
        case 'next':
          this.isPlay = false
          this._stop()
          this._next()
          break
        case 'refresh':
          this.isPlay = false
          this.index = this.imageGroup.length - 1
          this.setItem()
          this._stop()
          break
      }
    },
    setItem() {
      if (!this.imageGroup || this.imageGroup.length === 0) {
        return
      }
      const item: any = this.imageGroup[this.index]
      const imageBounds: any = [[31.01, 104], [40, 113]]
      this.time = item.datetime
      this.$emit('getImageGroupChange', {item, imageBounds})
    },
  },
})
